/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { FormControl, MenuItem, Select, withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import * as Constants from '../../constants'

const styles = {}

styles.languageContainer = css`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  margin: 20px;
  z-index: 99;
  border: 1px solid;
  border-radius: 5px;
  background: #eef5f4;

  &:hover {
    border-color: ${Constants.theme.palette.common.blue};
  }
`

styles.dropdownContainer = css`
  position: relative;
  width: 100%;
`

styles.selectFlag = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

styles.selectContainer = css`
  border-radius: 2px;
  background: transparent;
  width: 100%;
  text-align: center;
  height: 40px;
`

styles.selectForm = css`
  height: 40px;
  padding-left: 10px;
`

styles.selectOption = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

styles.languageLabel = css`
  display: flex;
  flex-grow: 1;
  padding-right: 20px;
`

styles.languageIcon = css`
  width: 36px;
`

const CssSelect = withStyles({
  select: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '0px',
    paddingBottom: '0px',
    '&:focus': {
      backgroundColor: 'transparent'
    }
  }
})(Select)

function LanguageSelect(props) {
  function onChangeLanguage(event) {
    props.onLanguageChange(event.target.value)
  }

  return (
    <div css={styles.languageContainer}>
      <div css={styles.dropdownContainer}>
        <FormControl css={styles.selectContainer}>
          <CssSelect
            disableUnderline
            onChange={onChangeLanguage}
            name="language"
            value={props.language}
            css={styles.selectForm}
          >
            {Object.values(Constants.Languages).map(v => (
              <MenuItem key={v.value} value={v.value} css={styles.selectOption}>
                <span css={styles.languageLabel}>{v.label}</span>
                <img src={v.icon} css={styles.languageIcon} />
              </MenuItem>
            ))}
          </CssSelect>
        </FormControl>
      </div>
    </div>
  )
}

LanguageSelect.propTypes = {
  language: PropTypes.string.isRequired,
  onLanguageChange: PropTypes.func.isRequired
}

export default LanguageSelect
